<script setup lang="ts">
import ApplicationBase from '../ApplicationBase.vue'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import Umsaekjandi from '../Shared/Umsaekjandi.vue';
import Step2 from './Steps/Step2.vue';
import Step3AddSamskuldari from './Steps/Step3AddSamskuldari.vue';
import Step3TakeOverLoan from './Steps/Step3TakeOverLoan.vue';
import Step4 from './Steps/Step4.vue';
import Step5 from './Steps/Step5.vue';
import Step6 from './Steps/Step6.vue';
import Step7 from './Steps/Step7.vue';
import Step8 from './Steps/Step8.vue';
import Step9 from './Steps/Step9.vue';
import Step10 from './Steps/Step10.vue';
import Undirritun from '../Shared/Undirritun.vue'
import ApplicationLanNafnabreytingBegin from './Steps/ApplicationLanNafnabreytingBegin.vue';
import PEP from '../Shared/PEP.vue';
import { watch } from 'vue'

const steps = [
  { comp: ApplicationLanNafnabreytingBegin, titleKey: '' },
  { comp: Umsaekjandi, titleKey: 'umsokn_umsaekjandi_header'},
  { comp: Step2, titleKey: 'lan_nafnabeyting_umsokn_step2_header1' },

  // branch after step2
  {
    comp: Step3AddSamskuldari,
    titleKey: 'lan_nafnabeyting_umsokn_step3_header',
    when: ({ umsokn }: { umsokn: { addSamskuldari?: boolean; takeOverLoan?: boolean } | null }) =>
      umsokn?.addSamskuldari === true
  },
  {
    comp: Step4,
    titleKey: 'lan_nafnabeyting_umsokn_step4_header1',
    when: ({ umsokn }: { umsokn: { addSamskuldari?: boolean; takeOverLoan?: boolean } | null }) =>
      umsokn?.addSamskuldari === true
  },
  {
    comp: Step3TakeOverLoan,
    titleKey: 'lan_nafnabeyting_umsokn_step5_header',
    when: ({ umsokn }: { umsokn: { addSamskuldari?: boolean; takeOverLoan?: boolean } | null }) =>
      umsokn?.takeOverLoan === true
  },

  // shared steps
  { comp: Step5, titleKey: 'lan_nafnabeyting_umsokn_step6_header1' },
  { comp: Step6, titleKey: 'lan_nafnabeyting_umsokn_step7_header1' },
  { comp: Step7, titleKey: 'lan_nafnabeyting_umsokn_step8_header1' },
  { comp: Step8, titleKey: 'lan_nafnabeyting_umsokn_step9_header1' },
  { comp: PEP,   titleKey: 'umsokn_PEP_header' },
  { comp: Step10, titleKey: 'lan_nafnabeyting_umsokn_step10_header1' },
  { comp: Step9, titleKey: 'umsokn_samantekt_header' },
  { comp: Undirritun, titleKey: 'undirritun_umsokn_header1' },
]


const { umsokn } = useUmsokn()


watch(
  () => umsokn.value,
  () => {
    if (!umsokn.value) return
    
    if (!umsokn.value.coDeptors) umsokn.value.coDeptors = []
    if (!umsokn.value.currentDeptorInformation) umsokn.value.currentDeptorInformation = []
    if (!umsokn.value.loanInformation) umsokn.value.loanInformation = []
    if (!umsokn.value.loantakers) umsokn.value.loantakers = []

    // objects that might come back as null but should at least be {} for binding
    if (!umsokn.value.takeOverLoanInformation) {
      umsokn.value.takeOverLoanInformation = {
        loanNumber: "",
        initialAmount: "",
        mortgage: null,
        issueDate: ""
      }
    }
  }
)


</script>

<template>
  <ApplicationBase :app-id="11" update-key="lan-nafnabreyting" :steps="steps" />
</template>
